export default __webpack_public_path__ + "9eb532cb933157efc2b252b6d9a3ae06.png";